import { Prompt } from "react-router-dom";
import React, { useEffect } from "react";
import { SignalRCore } from "../utils/signalR/core";

export function StopPageRefresh({ when, message = () => `You have unsaved changes! Are you sure you want leave?` }) {
  useEffect(() => {  
    const alertUser = (e) => {
      if (when) {
        e.preventDefault();
        e.returnValue = message();
      }
    };
    const disconnectHubs = (e) => {
      SignalRCore.closeAllConnections();
    };
    window.addEventListener("beforeunload", alertUser);
    window.addEventListener("beforeunload", disconnectHubs);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("beforeunload", disconnectHubs);
    };
  }, [when, message]);

  return <Prompt when={when} message={message} />;
}
